import { Types, GameObjects, Tilemaps } from 'phaser';
import { SecondPlayer } from './secondPlayer';
export class Player extends GameObjects.Sprite {
  moveKeys: any;
  up = false;
  down = false;
  right = false;
  left = false;
  speed = 0.05;
  body: Phaser.Physics.Arcade.Body;
  cursors;
  radius = 100;
  minRadius = 50;
  maxRadius = 300;
  second1: SecondPlayer;
  second2: SecondPlayer;
  secondColliding = false;
  walls: Tilemaps.StaticTilemapLayer;
  onTiles: Tilemaps.Tile[];
  radiusSpeed = 1.5;
  constructor(scene, startPoint, walls: Tilemaps.StaticTilemapLayer) {
    super(scene, 0, 0, 'player');
    this.createPrincess(startPoint);
    this.createKeyboard();
    this.walls = walls;
    this.second1 = new SecondPlayer(scene, this, 0, 'O', 'K', walls);
    this.second2 = new SecondPlayer(scene, this, 3.14, 'J', 'I', walls);
    this.scene.physics.add.collider(this, walls);
  }
  preUpdate = (time, delta) => {
    super.preUpdate(time, delta);
    this.body.setVelocity(0);
    this.second1.body.setVelocity(0);
    this.second2.body.setVelocity(0);
    this.onTiles = this.walls.getTilesWithinWorldXY(
      this.x,
      this.y,
      this.width,
      this.height
    );
    if (
      this.cursors.up.isDown &&
      !this.isOnWallTile([this.second1, this.second2], 0, -1)
    ) {
      this.body.setVelocityY(-100);
      if (!this.isOnWallTile([this], 0, -1)) {
        this.second1.body.setVelocityY(-100);
        this.second2.body.setVelocityY(-100);
      }
    }
    if (
      this.cursors.down.isDown &&
      !this.isOnWallTile([this.second1, this.second2], 0, 1)
    ) {
      this.body.setVelocityY(100);
      if (!this.isOnWallTile([this], 0, 1)) {
        this.second1.body.setVelocityY(100);
        this.second2.body.setVelocityY(100);
      }
    }
    if (
      this.cursors.right.isDown &&
      !this.isOnWallTile([this.second1, this.second2], 1, 0)
    ) {
      this.body.setVelocityX(100);
      if (!this.isOnWallTile([this], 1, 0)) {
        this.second1.body.setVelocityX(100);
        this.second2.body.setVelocityX(100);
      }
    }
    if (
      this.cursors.left.isDown &&
      !this.isOnWallTile([this.second1, this.second2], -1, 0)
    ) {
      this.body.setVelocityX(-100);
      if (!this.isOnWallTile([this], -1, 0)) {
        this.second1.body.setVelocityX(-100);
        this.second2.body.setVelocityX(-100);
      }
    }
    if (this.cursors.radiusIn.isDown) {
      let tmpRadius = this.radius - this.radiusSpeed;
      const [sec1x, sec1y] = this.getFutureXY(this.second1, tmpRadius);
      const [sec2x, sec2y] = this.getFutureXY(this.second2, tmpRadius);
      if (
        !this.isOnWallTile([this.second1], sec1x, sec1y) &&
        !this.isOnWallTile([this.second2], sec2x, sec2y)
      ) {
        this.radius -= this.radiusSpeed;
        if (this.radius < this.minRadius) {
          this.radius = this.minRadius;
        }
      }
    }
    if (this.cursors.radiusOut.isDown) {
      let tmpRadius = this.radius + this.radiusSpeed;
      const [sec1x, sec1y] = this.getFutureXY(this.second1, tmpRadius);
      const [sec2x, sec2y] = this.getFutureXY(this.second2, tmpRadius);
      if (
        !this.isOnWallTile([this.second1], sec1x, sec1y) &&
        !this.isOnWallTile([this.second2], sec2x, sec2y)
      ) {
        this.radius += this.radiusSpeed;
        if (this.radius > this.maxRadius) {
          this.radius = this.maxRadius;
        }
      }
    }
    // Update the animation last and give left/right animations precedence over up/down animations
    if (this.cursors.left.isDown) {
      this.flipX = true;
      this.anims.play('princess_walk_R', true);
    } else if (this.cursors.right.isDown) {
      this.flipX = false;
      this.anims.play('princess_walk_R', true);
    } else if (this.cursors.up.isDown) {
      this.anims.play('princess_walk_U', true);
    } else if (this.cursors.down.isDown) {
      this.anims.play('princess_walk_D', true);
    } else {
      this.anims.stop();
    }
  };

  // will figure out in which part of a the circle the player is to find the direction of where the second player is moving
  // when the circle expands or shrinks get the future position.
  private getFutureXY(secondPlayer: SecondPlayer, newRadius): [number, number] {
    const currVector = new Phaser.Math.Vector2(secondPlayer.x, secondPlayer.y);
    const futurePos = secondPlayer.getCirclePos(
      this.x,
      this.y,
      newRadius,
      secondPlayer.posRotation
    );
    const futureVector = new Phaser.Math.Vector2(futurePos.x, futurePos.y);
    let direction = futureVector.clone().subtract(currVector);
    return [direction.x, direction.y];
  }
  private createKeyboard() {
    this.cursors = this.scene.input.keyboard.addKeys({
      up: Phaser.Input.Keyboard.KeyCodes.W,
      down: Phaser.Input.Keyboard.KeyCodes.S,
      left: Phaser.Input.Keyboard.KeyCodes.A,
      right: Phaser.Input.Keyboard.KeyCodes.D,
      radiusIn: Phaser.Input.Keyboard.KeyCodes.Q,
      radiusOut: Phaser.Input.Keyboard.KeyCodes.E,
    });
  }

  private createPrincess(startPoint) {
    const walkConfig: Types.Animations.Animation = {
      key: 'princess_walk_U',
      frames: this.scene.anims.generateFrameNumbers('princess_walk_U', null),
      frameRate: 6,
      repeat: -1,
    };
    this.scene.anims.create({ ...walkConfig });
    walkConfig.key = 'princess_walk_D';
    walkConfig.frames = this.scene.anims.generateFrameNumbers(
      'princess_walk_D',
      null
    );
    this.scene.anims.create({ ...walkConfig });
    walkConfig.key = 'princess_walk_R';
    walkConfig.frames = this.scene.anims.generateFrameNumbers(
      'princess_walk_R',
      null
    );
    this.scene.anims.create({ ...walkConfig });
    this.scene.add.existing(this);
    this.scene.physics.add.existing(this);
    this.x = startPoint.x;
    this.y = startPoint.y;
    this.setOrigin(0, 0);
    this.setSize(16, 16);
    this.body.setSize(this.width, this.height, true);
    this.anims.load('princess_walk_D');
    this.anims.load('princess_walk_U');
    this.anims.load('princess_walk_R');
  }

  isOnWallTile = (gos: any[], x, y) => {
    let res = false;
    gos.forEach((go) => {
      let futureX = go.x + x;
      let futureY = go.y + y;
      const tiles = this.walls.getTilesWithinWorldXY(
        futureX,
        futureY,
        go.width,
        go.height
      );
      const isOnTile = tiles.find((tile) => tile.index != 1);
      if (isOnTile) res = true;
    });

    return res;
  };
}
